/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionItem } from '../../models/permission-item';

export interface AuthzPermissions$Plain$Params {
  resource?: string;
}

export function authzPermissions$Plain(http: HttpClient, rootUrl: string, params?: AuthzPermissions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionItem>>> {
  const rb = new RequestBuilder(rootUrl, authzPermissions$Plain.PATH, 'get');
  if (params) {
    rb.query('resource', params.resource, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PermissionItem>>;
    })
  );
}

authzPermissions$Plain.PATH = '/api/v1/platform/permissions';
